













import { Component, Vue } from 'vue-property-decorator';
import Timer from './components/Timer.vue';
import Cup from './components/Cup.vue';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default-dark.css'

Vue.use(VueMaterial);

@Component({
  components: {
    Timer,
    Cup
  },
})
export default class App extends Vue {}
